import { useSelector } from 'react-redux';

import { RoutingKey } from '@swf/core/enums';
import { select } from '@swf/core/store';
import { generatePath } from '@swf/core/utils/paths';

const useGetContentRoutes = () => {
  const { routes } = useSelector(select.page.getMeta);
  const cashGamesRoute = routes?.[RoutingKey.HomeGamesCashGames] || '';
  const clubsRoute = routes?.[RoutingKey.HomeGamesClubs] || '';
  const tournamentsRoute = routes?.[RoutingKey.HomeGamesTournaments] || '';
  const inviteRoute = routes?.[RoutingKey.HomeGamesInvite] || '';
  const landingRoute = routes?.[RoutingKey.HomeGamesLandingPage] || '';

  return {
    cashGamesPath: generatePath(cashGamesRoute, {}),
    clubsPath: generatePath(clubsRoute, {}),
    tournamentsPath: generatePath(tournamentsRoute, {}),
    invitePath: generatePath(inviteRoute, {}),
    landingPagePath: generatePath(landingRoute, {})
  };
};

export default useGetContentRoutes;
